// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Qvw4s","form":"style_form__h8Ni3","success":"style_success__rHnrZ","success_link":"style_success_link__ksbvu","error":"style_error__TykXs"};